import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Apollo } from 'apollo-angular';
import { User } from '../../entities/user/user';

import { FilterMetadata } from 'primeng/api';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { TableLazyLoadEvent } from 'primeng/table';
import { NXDataSourcePrime } from '../../services/dataSource/NXDataSourcePrime';
import { getLicenceTypes } from '../../entities/payment/payment';
import { LoadingService } from '../../services/loading.service';
import { ToastService } from '../../services/toast/toast.service';
import { EditDialogService } from '../editDialog/editDialogService';
import { UserDialogComponent } from '../user-dialog/user-dialog.component';
import { UserDataSource } from './userDataSource';

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.scss'],
})
export class UserListComponent implements OnDestroy, OnInit {

  dialogRef: DynamicDialogRef | undefined;

  public sortProperty: string;
  public defaultSortProperty: string = 'id';
  public sortDirection: string;
  public defaultSortDirection: string = 'asc';
  public pageNumber = 0;
  public pageSize = 15;
  public sortModel: any;
  public sortOptions = [
    { label: 'core.common.noSorting', fieldName: 'id', direction: "asc"},
    { label: 'core.userList.table.sorting.firstNameAsc', fieldName: 'firstName', direction: "asc"},
    { label: 'core.userList.table.sorting.firstNameDesc', fieldName: 'firstName', direction: "desc" },
    { label: 'core.userList.table.sorting.lastNameAsc', fieldName: 'lastName', direction: "asc"},
    { label: 'core.userList.table.sorting.lastNameDesc', fieldName: 'lastName', direction: "desc" },
    { label: 'core.userList.table.sorting.licenceTypeAsc', fieldName: 'licenceType', direction: "asc"},
    { label: 'core.userList.table.sorting.licenceTypeDesc', fieldName: 'licenceType', direction: "desc" }
  ] 

  public dataSource: UserDataSource;
  public loading = false;

  public email: string;
  public firstName: string;
  public lastName: string;
  public licenceType: any = [];
  public enabled: boolean;
  public licenceTypesModel: any[] = [];
  public statusModel: any;

  // public User = User;
  public licenceTypes = getLicenceTypes();
  public status = User.getStatus();

  constructor(
    private router: Router,
    private apollo: Apollo,
    @Inject('env') private environment : any,
    private cdRef: ChangeDetectorRef,
    public dialogService: EditDialogService,
    private loadingService: LoadingService,
    private toastService: ToastService
  ) {
  }

  ngOnInit(): void {
    this.dataSource = new UserDataSource(this.apollo, this.environment);
    this.dataSource.loading.subscribe((loading) => {
      this.loading = loading;
    });
    this.dataSource.loadUsers({
      pageNumber: 0,
      pageSize: 15,
      sortProperty: this.sortProperty ? this.sortProperty : this.defaultSortProperty,
      sortDirection: this.sortDirection ? this.sortDirection : this.defaultSortDirection,
      email: this.email,
      firstName: this.firstName,
      lastName: this.lastName,
      enabled: this.enabled,
      licenceType: this.licenceType
    });
  }

  refetchUsers(force = false): void {
    this.dataSource.refetchQuery({
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
      sortProperty: this.sortProperty,
      sortDirection: this.sortDirection,
      email: this.email,
      firstName: this.firstName,
      lastName: this.lastName,
      enabled: this.enabled,
      licenceType: this.licenceType
    }, force);
  }

  ngOnDestroy(): void {
    this.dataSource.disconnect();
  }

  loadData(event: TableLazyLoadEvent) {
    this.loading = true;

    // sorting
    if (event?.sortField !== undefined && typeof event?.sortField == 'string') {
      this.sortProperty = event.sortField;
    }
    if (event?.sortOrder !== undefined) {
      this.sortDirection = event.sortOrder === 1 ? 'asc' : 'desc';
    }

    //filtering
    if (event?.filters.email !== undefined) {
      this.email = (event.filters.email as FilterMetadata)?.value;
    }
    if (event?.filters.firstName !== undefined) {
      this.firstName = (event.filters.firstName as FilterMetadata)?.value;
    }
    if (event?.filters.lastName !== undefined) {
      this.lastName = (event.filters.lastName as FilterMetadata)?.value;
    }

    // type is not shwon as row so its an array of filterMetadata
    // but we use only the value at position 0
    let licenceTypeFilter = event?.filters?.licenceType as FilterMetadata;
    if (licenceTypeFilter?.value?.length > 0) {
      const values = licenceTypeFilter?.value;
      this.licenceType = values?.map((item: any) => item.id);
    } else {
      this.licenceType = undefined;
    }

    let enabledFilter = event?.filters?.enabled as FilterMetadata;
    if (enabledFilter?.value?.id != undefined) {
      this.enabled = enabledFilter?.value?.id;
    } else {
      this.enabled = undefined;
    }

    // pagination
    this.pageNumber = event?.first !== undefined ? event.first / event.rows : 0;
    this.pageSize = event?.rows !== undefined ? event.rows : 15;
    this.refetchUsers();
  }

  sort(event: any) {
    if(event?.value?.direction && event?.value?.fieldName){
      this.sortProperty = event.value.fieldName;
      this.sortDirection = event.value.direction;
    } else {
      this.sortProperty = this.defaultSortProperty;
      this.sortDirection = this.defaultSortDirection;
    }
    this.cdRef.detectChanges();
  }

  translateSortDirectionToSortOrder(sortDirection: string): number {
    return NXDataSourcePrime.translateSortDirectionToSortOrder(sortDirection);
  }

  createUser(): void {
    this.dialogRef = this.dialogService.open(UserDialogComponent, {
      header: 'core.userList.createUserDialog.header'
    });
    this.dialogRef.onClose.subscribe((result) => {
      // result is true or false, indiciating if it should refetch
      if(result){
        this.refetchUsers(true);
        this.loadingService.setLoading(false);
        this.toastService.addToastWithAction('core.userList.userCreated.successMessage', 'core.userList.userCreated.successActionLabel', () => {
          this.router.navigate(['./settings/users/user/' + result]);
        });
      }
    });
  }

  openUser(user: User): void {
    this.router.navigate(['./settings/users/user/' + user.id]);
  }


}
